import React, { useState } from 'react';
import { testimonials } from '../data/mock';
import { motion, AnimatePresence } from 'framer-motion';

const TestimonialsSection = () => {
  const [activeTab, setActiveTab] = useState(0);

  return (
    <section className="py-20 bg-white">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        <motion.h2
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="text-2xl md:text-3xl lg:text-4xl font-bold text-center mb-12"
        >
          Trusted By Leading <span className="text-[#2563EB]">Retailers & Restaurants</span>
        </motion.h2>

        {/* Tabs */}
        <div className="flex justify-center gap-6 mb-12">
          {testimonials.map((t) => (
            <button
              key={t.id}
              onClick={() => setActiveTab(t.id)}
              className={`p-2 rounded-xl border-2 transition-all duration-300 ${
                activeTab === t.id
                  ? 'border-[#2563EB] shadow-md'
                  : 'border-transparent hover:border-gray-200'
              }`}
            >
              <img
                src={t.logo}
                alt="Brand logo"
                className="h-10 w-auto object-contain"
              />
            </button>
          ))}
        </div>

        {/* Testimonial Content */}
        <AnimatePresence mode="wait">
          {testimonials.map(
            (t) =>
              activeTab === t.id && (
                <motion.div
                  key={t.id}
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  exit={{ opacity: 0, y: -20 }}
                  transition={{ duration: 0.4 }}
                  className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16"
                >
                  {/* Image */}
                  <div className="flex-1 flex justify-center">
                    <img
                      src={t.image}
                      alt="Testimonial"
                      className="max-w-full w-[500px] rounded-2xl"
                    />
                  </div>

                  {/* Text */}
                  <div className="flex-1">
                    <img
                      src={t.logo}
                      alt="Brand logo"
                      className="h-10 mb-6 object-contain"
                    />
                    <p className="text-gray-600 text-base leading-relaxed mb-6">
                      {t.quote}
                    </p>
                    <p className="font-bold text-gray-900">{t.author}</p>
                    <p className="text-sm text-gray-500">{t.role}</p>
                    {t.caseStudy && (
                      <a
                        href={t.caseStudy}
                        className="inline-block mt-4 text-[#2563EB] font-semibold text-sm hover:underline"
                      >
                        Download Case Study
                      </a>
                    )}
                  </div>
                </motion.div>
              )
          )}
        </AnimatePresence>
      </div>
    </section>
  );
};

export default TestimonialsSection;
